import OSS from 'ali-oss'
import { _getCookie } from '@/request/http.js'
import http from '@/request/index.js'
import BaseUrl from '@/request/base.js'
export default class AliOss {
  constructor(options) {
    ;(async () => {
      this.isAdmin = location.href.includes('accountid')
      this.credentials = null // STS凭证
      this.ossClient = null // oss客户端实例
      this.partSize = 1024 * 1024 * 60 // 每个分片大小(byte)-我设置了60兆
      this.parallel = 4 // 同时上传的分片数
      this.checkpoints = {} // 所有分片上传文件的检查点
      this.bucket = 'btw-paid-course'
      this.ossRegion = 'oss-cn-hangzhou'
      this.imageArr = []
      console.log('平台：', this.isAdmin)
      if (this.isAdmin) {
        this.authUrl =
          BaseUrl.adminUrlData[http.curEv()] +
          '/admin/AliyunAuth/getAuthForCourse'
      } else {
        this.authUrl = 'member/OssAuth/getAuthForCourse' // 授权链接
      }
      this.initOss()
    })()
  }

  async initOss() {
    let res
    if (this.isIniting) {
      return
    }
    this.isIniting = true
    if (this.isAdmin) {
      res = await http
        .get(this.authUrl, { key_token: http._getQuery('accountid') })
        .catch((err) => {
          console.error(err, 'initOSSClient异常，请刷新重试或联系管理员')
        })
    } else {
      res = await http.getApp(this.authUrl, {}).catch((err) => {
        console.error(err, 'initOSSClient异常，请刷新重试或联系管理员')
      })
    }
    this.isIniting = false
    if (!res) {
      return
    }
    res = res.data
    if (res.code === 200) {
      this.credentials = res.data

      const {
        AccessKeyId,

        AccessKeySecret,

        SecurityToken
      } = this.credentials
      try {
        const instance = new OSS({
          accessKeyId: AccessKeyId,

          accessKeySecret: AccessKeySecret,

          stsToken: SecurityToken,

          bucket: this.bucket,

          secure: true,

          region: this.ossRegion,

          // folder: 'course-audio',

          timeout: 1000 * 3600,

          refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。

            let res
            if (this.isAdmin) {
              res = await http
                .get(this.authUrl, {
                  key_token: http._getQuery('accountid')
                })
                .catch(() => {})
            } else {
              res = await http.getApp(this.authUrl, {}).catch(() => {})
            }
            res = res.data
            const { AccessKeyId, AccessKeySecret, SecurityToken } = res.data
            return {
              accessKeyId: AccessKeyId,

              accessKeySecret: AccessKeySecret,

              stsToken: SecurityToken
            }
          },

          // 刷新临时访问凭证的时间间隔，单位为毫秒。

          refreshSTSTokenInterval: 3600000
        })

        this.ossClient = instance
      } catch (error) {
        console.log(error, 'new oss')
      }
    } else {
      this.statusMsg = 'sts临时凭证获取失败，请刷新重试或联系管理员'
    }
  }

  uploadFile({ file }, folder) {
    if (this.ossClient) {
      let fileName = file.name.substr(0, file.name.lastIndexOf('.'))

      // 如果文件小于分片大小，使用普通上传，否则使用分片上传

      let fileInfo = {
        fileName: fileName,

        fileType: file.type,

        progress: 0,

        fileSize: file.size,

        status: 1 //上传状态
      }

      file.attrInfo = fileInfo

      if (file.size < this.partSize) {
        fileInfo.showValue = 1

        try {
          return this.commonUpload(folder, file, fileInfo)
        } catch (error) {
          console.log(error, 'commonUpload')
        }
      } else {
        fileInfo.showValue = 1

        try {
          return this.multipartUpload(folder, file, fileInfo)
        } catch (error) {
          console.log(error, 'multipartUpload')
        }
      }
    } else {
      console.error('initOSSClient异常，请刷新重试或联系管理员')
    }
  }

  //   普通上传

  commonUpload(folder, file, fileInfo) {
    const headers = {}

    const dateFolder = folder

    const dateStr = new Date().getTime()

    let fileName = file.name.substr(0, file.name.lastIndexOf('.'))

    const dirUrl = dateFolder + '/' + dateStr + '_' + fileName

    return this.ossClient.put(dirUrl, file, {
      headers,

      progress: this.onMultipartUploadProgress

      // 设置回调

      // callback: {

      //   // 设置回调请求的服务器地址。

      //   url: urlInfo.cdn_url,

      //   // 设置回调请求消息头中Host的值，即您的服务器配置Host的值。

      //   host: urlInfo.host,

      //   /* eslint no-template-curly-in-string: [0] */

      //   // 设置发起回调时请求body的值。

      //   body:

      //     'bucket=${bucket}&object=${object}&size=${size}&mimeType=${mimeType}',

      //   // 设置发起回调请求的Content-Type。

      //   contentType: 'multipart/form-data',

      //   //   contentType: 'application/x-www-form-urlencoded',

      //   // 设置发起回调请求的自定义参数。

      //   customValue: {

      //     'x:my_var': 'value1'

      //   }

      // }
    })

    // .then((result) => {

    //   console.log(`Common upload ${file.name} succeeded, result === `, result)

    //   fileInfo.fileName = result.name

    //   fileInfo.status = 2

    //   fileInfo.progress = 100

    // })

    // .catch((err) => {

    //   console.log(`Common upload ${file.name} failed === `, err)

    //   fileInfo.status = 0

    //   fileInfo.showValue = 0

    // })
  }

  //   分片

  multipartUpload(folder, file, fileInfo) {
    const headers = {}

    // const dateFolder = 'btw_course'

    const dateFolder = folder

    const dateStr = new Date().getTime()

    let fileName = file.name.substr(0, file.name.lastIndexOf('.'))

    const dirUrl = dateFolder + '/' + dateStr + '_' + fileName

    return this.ossClient.multipartUpload(dirUrl, file, {
      headers,

      parallel: this.parallel,

      partSize: this.partSize,

      progress: this.onMultipartUploadProgress

      // 不设回调

      // callback: {

      //   // 设置回调请求的服务器地址。

      //   url: urlInfo.cdn_url,

      //   // 设置回调请求消息头中Host的值，即您的服务器配置Host的值。

      //   host: urlInfo.host,

      //   /* eslint no-template-curly-in-string: [0] */

      //   // 设置发起回调时请求body的值。

      //   body:

      //     'bucket=${bucket}&object=${object}&size=${size}&mimeType=${mimeType}',

      //   // 设置发起回调请求的Content-Type。

      //   contentType: 'multipart/form-data',

      //   // 设置发起回调请求的自定义参数。

      //   customValue: {

      //     'x:my_var': 'value1'

      //   }

      // }
    })

    // .then((result) => {

    //   fileInfo.status = 2

    //   const url = `${dateFolder}/${dateStr}_${fileName}`

    //   console.log('文件名称', url)

    //   fileInfo.fileName = url

    // })

    // .catch((err) => {

    //   console.log(`Multipart upload ${file.name} failed === `, err)

    //   fileInfo.showValue = 0

    //   fileInfo.status = 0

    // })
  }

  getOssImg(fileUrl, options = {}) {
    if (this.ossClient) {
      if (fileUrl.length > 0) {
        // 普通链接直接返回
        if (
          fileUrl.includes('http') &&
          !fileUrl.includes('betterwe-paid-course.oss-cn-beijing.aliyuncs.com')
        ) {
          return fileUrl
        }

        if (fileUrl.includes('.com/')) {
          const fileName = fileUrl.split('.com/').pop()

          return this.ossClient.signatureUrl(fileName, options)
        }
        return this.ossClient.signatureUrl(fileUrl, options)
      }
    } else {
      return fileUrl
    }
  }
  onMultipartUploadProgress(progress, checkpoint) {
    console.log(`${checkpoint.file.name} 上传进度 ${progress}`)

    checkpoints[checkpoint.uploadId] = checkpoint

    checkpoint.file.attrInfo.progress = Math.round(progress * 100)
  }

  getAudionTime(file) {
    let fileUrl = URL.createObjectURL(file)
    let audioElement = new Audio(fileUrl)

    let time

    audioElement.addEventListener('loadedmetadata', function (_event) {
      time = Math.round(audioElement.duration)
    })

    return time
  }
}
const ProxyAliOss = new AliOss()
// 单例模式 防止实例过期的情况
export { ProxyAliOss }
